import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('customer_list')
        .setAdditionalRoutes([
            'customer_create',
            'customer_edit',
        ]),
    MenuEntry.create()
        .setRoute('customer_group_list')
        .setAdditionalRoutes([
            'customer_group_create',
            'customer_group_edit',
        ]),
];
